export const Urls = {

    ONLINE_URL: 'https://visitas.sys-dev.com.mx/proxy',

    ONLINE_PROXY: 'https://moviljal.cfe.mx/suterm/api.php'
}
